import { render, staticRenderFns } from "./UpdateEmailFields.vue?vue&type=template&id=27889a34&scoped=true&"
import script from "./UpdateEmailFields.vue?vue&type=script&lang=ts&"
export * from "./UpdateEmailFields.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateEmailFields.vue?vue&type=style&index=0&id=27889a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27889a34",
  null
  
)

export default component.exports